export const globalConfig = {
  pcUrl: 'https://www.hungrystudio.com',
  h5Url: 'https://www.hungrystudio.com/h5',
};
